import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const TeamsColor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      id="Vector"
      d="M10.6252 6.6667C12.236 6.6667 13.5419 5.36087 13.5419 3.75004C13.5419 2.13921 12.236 0.833374 10.6252 0.833374C9.01433 0.833374 7.7085 2.13921 7.7085 3.75004C7.7085 5.36087 9.01433 6.6667 10.6252 6.6667Z"
      fill="#7B83EB"
    />
    <path
      id="Vector_2"
      opacity="0.1"
      d="M10.4166 4.375H7.77563C7.77986 4.39445 7.7843 4.41388 7.78894 4.43329L7.79013 4.43817C7.79441 4.45603 7.79894 4.47384 7.80352 4.49161C7.99545 5.21949 8.46112 5.8451 9.10331 6.23783C9.7455 6.63056 10.5146 6.76005 11.25 6.59927V5.20832C11.2493 4.9875 11.1613 4.77592 11.0052 4.61978C10.849 4.46364 10.6374 4.37564 10.4166 4.375Z"
      fill="black"
    />
    <path
      id="Vector_3"
      opacity="0.2"
      d="M9.79171 5H7.98926C8.22587 5.49875 8.59915 5.92012 9.06573 6.21514C9.53232 6.51016 10.0731 6.66673 10.6251 6.66664V5.83332C10.6245 5.6125 10.5364 5.40092 10.3803 5.24478C10.2242 5.08864 10.0126 5.00064 9.79171 5Z"
      fill="black"
    />
    <path
      id="Vector_4"
      d="M17.1875 6.875C18.3956 6.875 19.375 5.89562 19.375 4.6875C19.375 3.47938 18.3956 2.5 17.1875 2.5C15.9794 2.5 15 3.47938 15 4.6875C15 5.89562 15.9794 6.875 17.1875 6.875Z"
      fill="#5059C9"
    />
    <path
      id="Vector_5"
      d="M19.0624 7.5H14.1494C14.0434 7.5 13.9418 7.54208 13.8669 7.61698C13.792 7.69189 13.7499 7.79348 13.7499 7.89941V12.9683C13.7363 13.7019 13.9752 14.4179 14.4264 14.9964C14.8777 15.5749 15.514 15.9808 16.2288 16.1462C16.6842 16.2418 17.1551 16.2346 17.6072 16.1251C18.0594 16.0157 18.4815 15.8068 18.8428 15.5137C19.204 15.2205 19.4954 14.8505 19.6955 14.4305C19.8957 14.0105 19.9997 13.5512 19.9999 13.086V8.4375C19.9999 8.18886 19.9011 7.95041 19.7253 7.7746C19.5495 7.59878 19.3111 7.50001 19.0624 7.5Z"
      fill="#5059C9"
    />
    <path
      id="Vector_6"
      d="M15.625 8.4375V14.375C15.6257 15.4754 15.2632 16.5453 14.5936 17.4185C13.9241 18.2918 12.985 18.9196 11.9222 19.2046C10.8593 19.4895 9.73211 19.4157 8.71553 18.9944C7.69894 18.5732 6.84984 17.8282 6.3 16.875C6.17973 16.6751 6.07525 16.4661 5.9875 16.25C5.9057 16.0462 5.83681 15.8375 5.78125 15.625C5.67821 15.2163 5.62574 14.7965 5.625 14.375V8.4375C5.62484 8.31434 5.64897 8.19236 5.69603 8.07854C5.74308 7.96472 5.81213 7.86131 5.89922 7.77422C5.98631 7.68713 6.08972 7.61808 6.20354 7.57103C6.31736 7.52397 6.43934 7.49984 6.5625 7.5H14.6875C14.8107 7.49984 14.9326 7.52397 15.0465 7.57103C15.1603 7.61808 15.2637 7.68713 15.3508 7.77422C15.4379 7.86131 15.5069 7.96472 15.554 8.07854C15.601 8.19236 15.6252 8.31434 15.625 8.4375Z"
      fill="#7B83EB"
    />
    <path
      id="Vector_7"
      opacity="0.2"
      d="M9.79171 5H7.98926C8.22587 5.49875 8.59915 5.92012 9.06573 6.21514C9.53232 6.51016 10.0731 6.66673 10.6251 6.66664V5.83332C10.6245 5.6125 10.5364 5.40092 10.3803 5.24478C10.2242 5.08864 10.0126 5.00064 9.79171 5Z"
      fill="black"
    />
    <path
      id="Vector_8"
      opacity="0.1"
      d="M11.25 7.5V15.4187C11.25 15.6072 11.1855 15.7899 11.0672 15.9365C10.949 16.0832 10.7841 16.185 10.6 16.225C10.5412 16.2425 10.4801 16.2509 10.4187 16.25H5.9875C5.9057 16.0462 5.83681 15.8375 5.78125 15.625C5.67821 15.2163 5.62574 14.7965 5.625 14.375V8.4375C5.62484 8.31434 5.64897 8.19236 5.69603 8.07854C5.74308 7.96472 5.81213 7.86131 5.89922 7.77422C5.98631 7.68713 6.08972 7.61808 6.20354 7.57103C6.31736 7.52397 6.43934 7.49984 6.5625 7.5H11.25Z"
      fill="black"
    />
    <path
      id="Vector_9"
      opacity="0.2"
      d="M10.625 7.5V16.0437C10.6259 16.1051 10.6175 16.1662 10.6 16.225C10.56 16.4091 10.4582 16.574 10.3115 16.6922C10.1649 16.8105 9.98215 16.875 9.79375 16.875H6.3C6.17973 16.6751 6.07525 16.4661 5.9875 16.25C5.9057 16.0462 5.83681 15.8375 5.78125 15.625C5.67821 15.2163 5.62574 14.7965 5.625 14.375V8.4375C5.62484 8.31434 5.64897 8.19236 5.69603 8.07854C5.74308 7.96472 5.81213 7.86131 5.89922 7.77422C5.98631 7.68713 6.08972 7.61808 6.20354 7.57103C6.31736 7.52397 6.43934 7.49984 6.5625 7.5H10.625Z"
      fill="black"
    />
    <path
      id="Vector_10"
      opacity="0.2"
      d="M10.625 7.5V14.7937C10.624 15.0139 10.5361 15.2248 10.3805 15.3805C10.2248 15.5361 10.0139 15.624 9.79375 15.625H5.78125C5.67821 15.2163 5.62574 14.7965 5.625 14.375V8.4375C5.62484 8.31434 5.64897 8.19236 5.69603 8.07854C5.74308 7.96472 5.81213 7.86131 5.89922 7.77422C5.98631 7.68713 6.08972 7.61808 6.20354 7.57103C6.31736 7.52397 6.43934 7.49984 6.5625 7.5H10.625Z"
      fill="black"
    />
    <path
      id="Vector_11"
      opacity="0.2"
      d="M6.5625 7.5C6.43934 7.49984 6.31736 7.52397 6.20354 7.57103C6.08972 7.61808 5.98631 7.68713 5.89922 7.77422C5.81213 7.86131 5.74308 7.96472 5.69603 8.07854C5.64897 8.19236 5.62484 8.31434 5.625 8.4375V14.375C5.62574 14.7965 5.67821 15.2163 5.78125 15.625H9.16875C9.38891 15.624 9.59978 15.5361 9.75546 15.3805C9.91114 15.2248 9.99903 15.0139 10 14.7937V7.5H6.5625Z"
      fill="black"
    />
    <path
      id="Vector_12"
      d="M0.833331 5H9.16668C9.38769 5 9.59965 5.08781 9.75593 5.24409C9.91221 5.40037 10 5.61233 10 5.83334V14.1667C10 14.3877 9.91221 14.5996 9.75593 14.7559C9.59965 14.9122 9.3877 15 9.16669 15H0.833337C0.612322 15 0.40036 14.9122 0.244079 14.7559C0.0877975 14.5996 0 14.3877 0 14.1667V5.83333C0 5.61232 0.0877975 5.40036 0.244077 5.24408C0.400357 5.0878 0.612318 5 0.833331 5Z"
      fill="#4B53BC"
    />
    <path
      id="Vector_13"
      d="M7.48291 8.10868H5.6184V13.1214H4.39302V8.10868H2.5177V6.8772H7.48291V8.10868Z"
      fill="white"
    />
  </Icon>
));

export default TeamsColor;
